import { render, staticRenderFns } from "./WidgetNode.vue?vue&type=template&id=ed0cbd52&scoped=true&"
import script from "./WidgetNode.vue?vue&type=script&lang=js&"
export * from "./WidgetNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0cbd52",
  null
  
)

export default component.exports